var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flashcard-footer-button",on:{"click":_vm.handleBookmarkClick}},[(_vm.hasBookmark)?_c('icon',{staticClass:"flashcard-footer-icon",attrs:{"name":"flag-filled","variant":_vm.variant}}):_c('icon',{staticClass:"flashcard-footer-icon",attrs:{"name":"flag-outline","variant":_vm.variant}}),_vm._v("\n  Flag\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }